import React from 'react';
import { Container, Box, Typography, Grid, Paper, Stack, Chip, List, ListItem, ListItemIcon, ListItemText } from '@mui/material';
import { Payment as PaymentIcon, CheckCircle as CheckIcon } from '@mui/icons-material';
import { theme, commonStyles } from '../../../styles/theme';
import { pricingHighlights, pricingSupport } from './homePageData.jsx';
import PricingCalculator from '../../Pricing/PricingCalculator';

const PricingTab = ({ conversionRates, pricesLoading, pricesError }) => {
	return (
		<Container maxWidth="lg" sx={{ py: { xs: 4, md: 8 }, px: { xs: 2, sm: 3 } }}>
			<Box sx={{ textAlign: 'center', mb: { xs: 4, md: 6 } }}>
				<Chip label="Free to Build" icon={<PaymentIcon />} sx={{ mb: 3, px: 3, py: 2, fontWeight: 700, bgcolor: 'rgba(16,185,129,0.12)', color: '#34d399', border: '1px solid rgba(16,185,129,0.2)' }} />
				<Typography variant="h3" sx={{ fontWeight: 800, ...commonStyles.gradientText, mb: 2 }}>
					Free tier — deploy through Gravemint
				</Typography>
				<Typography variant="body1" sx={{ color: theme.colors.textSecondary, maxWidth: 840, mx: 'auto' }}>
					GraveForge is free to use for building and previewing NFT collections. When you're ready to deploy, export to Gravemint for multi-chain minting, metadata uploads, and launch management.
				</Typography>
			</Box>

			<Grid container spacing={{ xs: 2, md: 3 }} sx={{ mb: { xs: 4, md: 6 } }}>
				{pricingHighlights.map((item) => (
					<Grid item xs={12} md={4} key={item.label}>
						<Paper sx={{ ...commonStyles.card, p: 3, height: '100%', borderRadius: 4, border: `1px solid ${theme.colors.borderPrimary}` }}>
							<Stack spacing={1.5}>
								<Box sx={{ width: 48, height: 48, borderRadius: 2, display: 'flex', alignItems: 'center', justifyContent: 'center', bgcolor: 'rgba(255,255,255,0.05)', border: `1px solid ${theme.colors.borderPrimary}` }}>
									{item.icon}
								</Box>
								<Typography variant="subtitle1" sx={{ fontWeight: 700, color: '#fff' }}>{item.label}</Typography>
								<Typography variant="body2" sx={{ color: 'rgba(255,255,255,0.72)', lineHeight: 1.6 }}>
									{item.description}
								</Typography>
							</Stack>
						</Paper>
					</Grid>
				))}
			</Grid>

			<Grid container spacing={{ xs: 2, md: 4 }} alignItems="stretch">
				<Grid item xs={12} lg={7}>
					<Paper sx={{ ...commonStyles.card, borderRadius: 4, border: `1px solid ${theme.colors.borderPrimary}`, p: { xs: 2, sm: 3, md: 4 }, height: '100%' }}>
						<Typography variant="h5" sx={{ fontWeight: 800, color: '#fff', mb: 2 }}>Estimate exports in seconds</Typography>
						<Typography variant="body2" sx={{ color: 'rgba(255,255,255,0.65)', mb: 3 }}>
							Live conversion rates for SOL, ETH, and DEADS help finance teams plan budgets before a single job runs.
						</Typography>
						<PricingCalculator conversionRates={conversionRates} pricesLoading={pricesLoading} pricesError={pricesError} />
					</Paper>
				</Grid>
				<Grid item xs={12} lg={5}>
					<Stack spacing={2.5}>
						{pricingSupport.map((section) => (
							<Paper key={section.title} sx={{ ...commonStyles.card, borderRadius: 4, p: { xs: 2, sm: 3 }, border: `1px solid ${theme.colors.borderPrimary}` }}>
								<Stack spacing={1.5}>
									<Typography variant="subtitle1" sx={{ fontWeight: 700, color: section.accent }}>{section.title}</Typography>
									<List dense disablePadding>
										{section.items.map((item, idx) => (
											<ListItem key={idx} sx={{ px: 0, py: 0.4 }}>
												<ListItemIcon sx={{ minWidth: 28 }}>
													<CheckIcon sx={{ fontSize: 18, color: section.accent }} />
												</ListItemIcon>
												<ListItemText primary={item} primaryTypographyProps={{ color: 'rgba(255,255,255,0.7)', variant: 'body2' }} />
											</ListItem>
										))}
									</List>
								</Stack>
							</Paper>
						))}
					</Stack>
				</Grid>
			</Grid>

			<Box sx={{ mt: 6, textAlign: 'center' }}>
				<Typography variant="caption" sx={{ color: 'rgba(255,255,255,0.55)' }}>
					Need custom billing or migration assistance? Contact the Solana Deads enterprise desk from the dashboard.
				</Typography>
			</Box>
		</Container>
	);
};

export default PricingTab;
